import { render, staticRenderFns } from "./SelectOrder.vue?vue&type=template&id=b6a4251a&"
import script from "./SelectOrder.vue?vue&type=script&lang=js&"
export * from "./SelectOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports